import { render } from "./DonorManagementPage.vue?vue&type=template&id=e3ec257e&scoped=true"
import script from "./DonorManagementPage.vue?vue&type=script&lang=js"
export * from "./DonorManagementPage.vue?vue&type=script&lang=js"

import "./DonorManagementPage.vue?vue&type=style&index=0&id=e3ec257e&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3ec257e"]])

export default __exports__